import { render } from "./DueSoon.vue?vue&type=template&id=717f548a&scoped=true"
import script from "./DueSoon.vue?vue&type=script&lang=js"
export * from "./DueSoon.vue?vue&type=script&lang=js"

import "./DueSoon.vue?vue&type=style&index=0&id=717f548a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717f548a"]])

export default __exports__